import React from "react"
import { FormattedMessage } from "react-intl"
import LabelBadge from "../label/badge.component"
import { UpdateStatusBadgeProps } from "../types/badge/types"

function UpdateStatusBadge(props: UpdateStatusBadgeProps) {    
    switch (props.status) {
    case "modified":
        return (
            <span className={LabelBadge.getBadgeClassName(props.status)}>
                <FormattedMessage
                    id="listing.labels.type.modified_label"
                    defaultMessage="Modified"
                />
            </span>
        )
    case "deleted":
        return (
            <span className={LabelBadge.getBadgeClassName(props.status)}>
                <FormattedMessage
                    id="listing.labels.type.deleted_label"
                    defaultMessage="Deleted"
                />
            </span>
        )
    default:
        return <span />
    }
}

export default UpdateStatusBadge


// WEBPACK FOOTER //
// ./src/common/badge/UpdateStatusBadge.tsx